import {Controller} from "@hotwired/stimulus"

/**
 * TemplateController allows to add another element to the scopeTarget from
 * the template target. All occurrences of __COUNTER__ in the template will be
 * replaced by an incrementing counter.
 */
export default class extends Controller {
  static targets = ['scope', 'template']
  static values = {
    counter: Number
  }

  addAnother() {
    const content = this.templateTarget.innerHTML.replaceAll('__COUNTER__', this.counterValue);
    this.scopeTarget.insertAdjacentHTML('beforeend', content);
    this.counterValue++;
  }
}